import {Box, Button, Modal, Typography} from "@mui/material";
import React from "react";
import {WarningRounded} from "@mui/icons-material";

const DeleteSiteModal = ({
                           deleteModalOpen,
                           setDeleteModalOpen,
                           handleDeleteSite,
                         }) => {
  const handleClose = () => {
    setDeleteModalOpen(false);
  };
  const handleDelete = () => {
    handleDeleteSite();
  };

  return (
    <>
      <Modal open={deleteModalOpen} onClose={handleClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 3,
            borderRadius: 2,
            textAlign: "center",
          }}
          className='delete-site-modal'
        >
          <Box sx={{marginBottom: "40px"}}>
            <Box sx={{display: "flex"}}>
              <Typography
                color="error"
                sx={{
                  background: "rgb(250 212 212)",
                  width: "50px",
                  height: "50px",
                  borderRadius: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginTop: "4px",
                }}
              >
                <WarningRounded />
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "flex-start",
                  alignItems: "flex-start",
                  marginLeft: "12px",
                }}
              >
                <Typography
                  variant="h6"
                  sx={{fontSize: "18px", marginBottom: "5px"}}
                >
                  Delete Site
                </Typography>
                <Typography
                  sx={{fontSize: "14px", color: "#9c9b9b"}}
                >
                  Are you sure you want to delete this site?
                </Typography>
              </Box>
            </Box>
          </Box>
          <Box sx={{mt: 2, display: "flex", justifyContent: "space-between"}}>
            <Button
              onClick={handleClose}
              sx={{
                textTransform: "none",
                width: "48%",
                border: "1px solid gray",
                color: "gray",
                fontWeight: "500",
                fontSize: "15px",
                "&:hover": {color: "gray",background: '#faf9f9'},
              }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              sx={{
                width: "48%",
                fontWeight: "500",
                fontSize: "15px",
                background: "#fc4f4f !important",
                color: "white !important",
                "&:hover": {
                  background: "#fc4f4f",
                  color: "white !important",
                },
              }}
              onClick={handleDelete}
            >
              Delete
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default DeleteSiteModal;
